export const STEPS = {
  ENTER_DOMAIN: 'ENTER_DOMAIN',
  FREE_DOMAIN_STORE: 'FREE_DOMAIN_STORE',
  FREE_DOMAIN_ONLINE: 'FREE_DOMAIN_ONLINE',
  SUCCESS: 'SUCCESS',
};

export const initialStep = STEPS.ENTER_DOMAIN;
